<template>
  <div
    class="teacher-container"
    :class="{
      'speaking-box': isSpeaking,
    }"
  >
    <div
      class="video-box"
      ref="preview_video"
      :id="info.userID + '_video'"
    ></div>
    <div class="close-placeholder" v-if="cameraClose">
      <img :src="info.avatar" />
    </div>
    <div class="handle-box" v-if="showHandleBox">
      <div class="audio handle-item" @click="handleChangeAudioStatus">
        <img
          v-if="isMicLoading"
          src="@saas/pages/assets/images/live/loading.png"
          alt=""
          class="loading-icon"
        />
        <img
          v-else-if="micClose"
          src="@saas/pages/assets/images/live/micro-slash.png"
          alt=""
        />
        <img v-else src="@saas/pages/assets/images/live/micro.png" alt="" />
      </div>
      <div
        class="video handle-item"
        @click="handleChangeVideoStatus"
        v-if="roomInfo.mode != 1"
      >
        <img
          v-if="isCameraLoading"
          src="@saas/pages/assets/images/live/loading.png"
          alt=""
          class="loading-icon"
        />
        <img
          v-else-if="cameraClose"
          src="@saas/pages/assets/images/live/video-slash.png"
          alt=""
        />
        <img v-else src="@saas/pages/assets/images/live/video.png" alt="" />
      </div>
      <div class="video handle-item">
        <el-dropdown class="person-dropdown" @command="handleCommand">
          <img src="@saas/pages/assets/images/live/more-point.png" alt="" />
          <el-dropdown-menu slot="dropdown" class="person-dropdown-menu">
            <el-dropdown-item command="mirror">镜像</el-dropdown-item>
            <el-dropdown-item command="rename">修改课中昵称</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
    </div>
    <div class="info-box">
      <div class="role">
        {{ getRole() }}
      </div>
      <img
        v-if="micClose"
        src="@saas/pages/assets/images/live/mic-close.png"
        alt=""
      />
      <img
        v-else-if="isSpeaking"
        src="@saas/pages/assets/images/live/mic-open.png"
        alt=""
      />
      <img v-else src="@saas/pages/assets/images/live/micro.png" alt="" />
      <div class="name ellipsis">{{ info.name || "未知" }}</div>
    </div>
  </div>
</template>

<script>
import { mapMutations, mapState } from "vuex";
import { setUserRole } from "@saas/server-api/src/live-sdk";
import screenShare from "../mixins/screen-share";
import handleSelf from "../mixins/handle-self";
import {
  createQueueAsyncFn,
  debounce,
} from "@saas/components/src/utils/debounce-async";
import { uploadLiveLog } from "@saas/components/src/utils/log";
export default {
  mixins: [screenShare, handleSelf],
  props: {
    teacherInfo: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  data() {
    return {
      isSpeaking: false,
      info: {},
      speakTimer: null,
      // 状态检查相关
      statusCheckTimer: null,
      lastAudioState: null, // 本地音频状态记录
      lastVideoState: null,
      statusCheckInterval: 3000, // 3秒检查一次状态
      queueAsyncRemoteAudio: createQueueAsyncFn(),
      queueAsyncRemoteVideo: createQueueAsyncFn(),
      muteRemoteAudioState: null,
      muteRemoteVideoState: null,
      isMicLoading: false,
      isCameraLoading: false,
    };
  },
  watch: {
    teacherInfo: {
      handler(val) {
        if (val) {
          this.info = { ...val };
        }
      },
      deep: true,
    },
    "teacherInfo.videoClose": {
      handler(val) {
        if (this.teacherInfo.isMe) {
          this.switchLocalVideoStatus();
        } else {
          // 快直播场景下，下台学生或助教不订阅老师的 TRTC 视频流
          if (
            this.roomInfo.is_quick_live === 1 &&
            (this.roomInfo.isStudent || this.roomInfo.isAssistant) &&
            this.userStatus.is_up_stage === 2 &&
            !this.isRecordPage
          ) {
            return;
          }
          const isOpen = !val && this.teacherInfo.isReciveStream;
          if (isOpen) {
            this.startRemoteVideo();
          } else {
            this.stopRemoteVideo();
          }
          uploadLiveLog({
            message: `监听--用户${isOpen ? "开启" : "关闭"}远端用户摄像头`,
            level: "info",
            tag: "callback",
            extra: {
              component: "TeacherVideo",
              targetUserId: this.teacherInfo.userID,
              isOpen,
              videoClose: val,
            },
          });
        }
      },
    },
    "teacherInfo.audioClose": {
      handler(val) {
        if (this.teacherInfo.isMe) {
          this.switchLocalAudioStatus();
        } else {
          // 快直播场景下，下台学生或助教不订阅老师的 TRTC 音频流
          if (
            this.roomInfo.is_quick_live === 1 &&
            (this.roomInfo.isStudent || this.roomInfo.isAssistant) &&
            this.userStatus.is_up_stage === 2 &&
            !this.isRecordPage
          ) {
            return;
          }
          const isMute = !(!val && this.teacherInfo.isReciveAudioStream);
          this.muteRemoteAudio(isMute);
          uploadLiveLog({
            message: `监听--用户${isMute ? "关闭" : "开启"}远端用户麦克风`,
            level: "info",
            tag: "callback",
            extra: {
              component: "TeacherVideo",
              targetUserId: this.teacherInfo.userID,
              isMute,
              audioClose: val,
            },
          });
        }
      },
    },
    "teacherInfo.isReciveStream": {
      handler(val) {
        console.log("isReciveStream_teacherInfo", this.teacherInfo.userID);
        console.log("isReciveStream_teacherInfo---val", val);
        if (!this.teacherInfo.isMe) {
          // 快直播场景下，下台学生或助教不订阅老师的 TRTC 视频流
          if (
            this.roomInfo.is_quick_live === 1 &&
            (this.roomInfo.isStudent || this.roomInfo.isAssistant) &&
            this.userStatus.is_up_stage === 2 &&
            !this.isRecordPage
          ) {
            return;
          }
          const isOpen = val && !this.teacherInfo.videoClose;
          if (isOpen) {
            this.startRemoteVideo();
          } else {
            this.stopRemoteVideo();
          }
          uploadLiveLog({
            message: `监听--用户${isOpen ? "开启" : "关闭"}远端用户摄像头推流`,
            level: "info",
            tag: "callback",
            extra: {
              component: "TeacherVideo",
              targetUserId: this.teacherInfo.userID,
              isOpen,
              isReciveStream: val,
            },
          });
        }
      },
    },
    "teacherInfo.isReciveAudioStream": {
      handler(val) {
        if (!this.teacherInfo.isMe) {
          // 快直播场景下，下台学生或助教不订阅老师的 TRTC 音频流
          if (
            this.roomInfo.is_quick_live === 1 &&
            (this.roomInfo.isStudent || this.roomInfo.isAssistant) &&
            this.userStatus.is_up_stage === 2 &&
            !this.isRecordPage
          ) {
            return;
          }
          const isMute = !(val && !this.teacherInfo.audioClose);
          this.muteRemoteAudio(isMute);
          uploadLiveLog({
            message: `监听--用户${isMute ? "关闭" : "开启"}远端用户麦克风推流`,
            level: "info",
            tag: "callback",
            extra: {
              component: "TeacherVideo",
              targetUserId: this.teacherInfo.userID,
              isMute,
              isReciveAudioStream: val,
            },
          });
        }
      },
    },
    speakerVolume: {
      handler(val) {
        if (this.liveService) {
          this.liveService.setRemoteAudioVolume({
            userId: this.info.userID,
            volume: val,
          });
        }
      },
    },
    // 监听学生或助教上下台状态变化，触发流切换
    "userStatus.is_up_stage": {
      handler(val, oldVal) {
        // 只有快直播学生或助教且不是自己才需要处理
        if (
          this.roomInfo.is_quick_live === 1 &&
          (this.roomInfo.isStudent || this.roomInfo.isAssistant) &&
          !this.teacherInfo.isMe &&
          oldVal !== undefined &&
          !this.isRecordPage
        ) {
          uploadLiveLog({
            message: "学生或助教上下台状态变化，触发老师流切换",
            level: "info",
            tag: "api",
            extra: {
              component: "TeacherVideo",
              action: "is_up_stage_change",
              oldVal,
              newVal: val,
              teacherUserId: this.teacherInfo.userID,
            },
          });

          if (val === 1 && oldVal === 2) {
            // 学生或助教从下台变成上台，重新订阅老师的 TRTC 流
            uploadLiveLog({
              message: "学生或助教上台，重新订阅老师的 TRTC 流",
              level: "info",
              tag: "api",
              extra: {
                component: "TeacherVideo",
                action: "resubscribe_teacher_stream",
                teacherUserId: this.teacherInfo.userID,
              },
            });
            this.$nextTick(() => {
              this.initRemote();
            });
          } else if (val === 2 && oldVal === 1) {
            // 学生或助教从上台变成下台，停止订阅老师的 TRTC 流
            uploadLiveLog({
              message: "学生或助教下台，停止订阅老师的 TRTC 流",
              level: "info",
              tag: "api",
              extra: {
                component: "TeacherVideo",
                action: "unsubscribe_teacher_stream",
                teacherUserId: this.teacherInfo.userID,
              },
            });
            // 先静音音频流，防止音频流继续播放
            this.muteRemoteAudio(true);
            // 停止视频流，在TRTC中停止主视频流（streamType: 0）会自动停止对应的音频流
            this.stopRemoteVideo().then(() => {
              // 停止视频流后，再次确保音频流被静音（防止音频流没有被正确停止）
              // 注意：这里再次静音是为了确保音频流状态被正确更新
              this.muteRemoteAudio(true);
              uploadLiveLog({
                message: "学生或助教下台，已停止老师的 TRTC 视频和音频流",
                level: "info",
                tag: "api",
                extra: {
                  component: "TeacherVideo",
                  action: "unsubscribe_teacher_stream_complete",
                  teacherUserId: this.teacherInfo.userID,
                },
              });
            });
          }
        }
      },
    },
  },
  computed: {
    ...mapState("live", [
      "cameraList",
      "liveService",
      "imService",
      "microphoneList",
      "speakerList",
      "layout",
      "isMirror",
      "roomInfo",
      "showRaiseHand",
      "videoPermission",
      "audioPermission",
      "currentCameraDevice",
      "remoteScreenShareInfo",
      "screenShareStatus",
      "userStatus",
      "speakerVolume",
      "isRecordPage",
    ]),
    // 是否在接收共享（）
    isScreenShareRemote() {
      return ["start", "pause"].includes(this.remoteScreenShareInfo.status);
    },
    micClose() {
      return this.info.audioClose || (!this.audioPermission && this.info.isMe);
    },
    cameraClose() {
      return this.info.videoClose || (!this.videoPermission && this.info.isMe);
    },
    showHandleBox() {
      if (this.info.isMe) {
        if (!window.isElectron) {
          return this.layout !== "speaker";
        } else {
          if (this.layout === "speaker" && !this.isScreenShare) {
            return false;
          }
          return true;
        }
      } else {
        return false;
      }
    },
    // 是否在共享
    isScreenShare() {
      return ["start", "pause"].includes(this.screenShareStatus);
    },
  },
  mounted() {
    this.init();
    // this.liveService.enableAudioVolumeEvaluation();
    this.liveService.on("audioVolumnChange", this.onVolumeChange);
    uploadLiveLog({
      message: "TeacherVideo组件挂载",
      level: "info",
      tag: "lifecycle",
      extra: {
        component: "TeacherVideo",
        userId: this.teacherInfo.userID,
        isMe: this.teacherInfo.isMe,
      },
    });
  },
  beforeDestroy() {
    // this.stopStatusCheck();
    if (this.info.isMe) {
      this.stopLocalVideo();
      this.muteLocalAudio(true);
    } else {
      this.stopRemoteVideo();
      this.muteRemoteAudio(true);
    }
    this.liveService.off("audioVolumnChange", this.onVolumeChange);
    clearTimeout(this.speakTimer);
    uploadLiveLog({
      message: "TeacherVideo组件销毁",
      level: "info",
      tag: "lifecycle",
      extra: {
        component: "TeacherVideo",
        userId: this.info.userID,
        isMe: this.info.isMe,
      },
    });
  },
  methods: {
    ...mapMutations("live", [
      "setUserStatus",
      "setPullStreamState",
      "setShowChangeNickname",
    ]),
    getRole() {
      if (this.info.isTeacher) {
        return "教师";
      } else if (this.info.isAssistant) {
        return "助教";
      } else {
        return "学生";
      }
    },
    init() {
      this.info = { ...this.teacherInfo };
      if (this.info.isMe) {
        this.switchLocalAudioStatus();
        this.switchLocalVideoStatus();
        uploadLiveLog({
          message: "教师初始化自己的麦克风和摄像头状态",
          level: "info",
          tag: "userAction",
          extra: {
            component: "TeacherVideo",
            targetUserId: this.info.userID,
            videoClose: this.info.videoClose,
            audioClose: this.info.audioClose,
          },
        });
      } else {
        this.initRemote();
        uploadLiveLog({
          message: "初始化远端教师的麦克风和摄像头状态",
          level: "info",
          tag: "userAction",
          extra: {
            component: "TeacherVideo",
            targetUserId: this.info.userID,
            isReciveStream: this.info.isReciveStream,
            videoClose: this.info.videoClose,
            audioClose: this.info.audioClose,
            isReciveAudioStream: this.info.isReciveAudioStream,
          },
        });
      }
    },
    initRemote() {
      // 快直播场景下，下台学生或助教不订阅老师的 TRTC 视频和音频流（改用 CDN）
      if (
        this.roomInfo.is_quick_live === 1 &&
        (this.roomInfo.isStudent || this.roomInfo.isAssistant) &&
        this.userStatus.is_up_stage === 2 &&
        !this.isRecordPage
      ) {
        uploadLiveLog({
          message: "快直播下台学生或助教不订阅老师的 TRTC 流",
          level: "info",
          tag: "api",
          extra: {
            component: "TeacherVideo",
            action: "initRemote",
            isStudent: this.roomInfo.isStudent,
            isAssistant: this.roomInfo.isAssistant,
            is_up_stage: this.userStatus.is_up_stage,
            targetUserId: this.info.userID,
            is_quick_live: this.roomInfo.is_quick_live,
          },
        });
        return;
      }

      this.liveService.setRemoteAudioVolume({
        userId: this.info.userID,
        volume: this.speakerVolume,
      });
      // 远端用户
      if (this.info.isReciveStream && !this.info.videoClose) {
        // 远端用户开始推流
        this.startRemoteVideo();
      }
      if (this.info.isReciveAudioStream && !this.info.audioClose) {
        // 远端用户音频推流
        this.muteRemoteAudio(false);
      }
    },
    // 切换音频状态
    switchLocalAudioStatus() {
      if (this.info.isMe) {
        if (this.info.audioClose) {
          this.muteLocalAudio(true);
        } else {
          this.muteLocalAudio(false);
        }
      }
    },
    // 切换视频状态
    switchLocalVideoStatus() {
      if (this.info.isMe) {
        if (this.info.videoClose) {
          this.stopLocalVideo();
        } else {
          this.startLocalVideo();
        }
      }
    },
    // 手动切换音频状态
    handleChangeAudioStatus: debounce(
      function () {
        if (this.info.isMe) {
          if (this.isMicLoading) {
            return;
          }
          this.isMicLoading = true;
          const newAudioState = !this.info.audioClose;
          uploadLiveLog({
            message: `教师点击${
              newAudioState ? "开启" : "关闭"
            }自己的麦克风按钮`,
            level: "info",
            tag: "userAction",
            extra: {
              component: "TeacherVideo",
              action: "toggleSelfAudio",
              newState: newAudioState,
              userId: this.info.userID,
            },
          });
          this.handleSelfMic(newAudioState)
            .then(() => {
              this.isMicLoading = false;
              uploadLiveLog({
                message: `教师${
                  newAudioState ? "开启" : "关闭"
                }自己的麦克风成功`,
                level: "info",
                tag: "userAction",
                extra: {
                  component: "TeacherVideo",
                  action: "toggleSelfAudio",
                  newState: newAudioState,
                  userId: this.info.userID,
                },
              });
            })
            .catch((error) => {
              this.isMicLoading = false;
              uploadLiveLog({
                message: `教师${
                  newAudioState ? "开启" : "关闭"
                }自己的麦克风失败`,
                level: "error",
                tag: "userAction",
                extra: {
                  component: "TeacherVideo",
                  action: "toggleSelfAudio",
                  error: error?.message || error,
                },
              });
            });
        }
      },
      300,
      true
    ),
    // 手动切换视频状态
    handleChangeVideoStatus: debounce(
      function () {
        if (this.info.isMe) {
          if (this.isCameraLoading) {
            return;
          }
          this.isCameraLoading = true;
          const newVideoState = !this.info.videoClose;
          uploadLiveLog({
            message: `教师点击${
              newVideoState ? "开启" : "关闭"
            }自己的摄像头按钮`,
            level: "info",
            tag: "userAction",
            extra: {
              component: "TeacherVideo",
              action: "toggleSelfVideo",
              newState: newVideoState,
              userId: this.info.userID,
            },
          });
          this.handleSelfCamera(newVideoState, this.$refs.preview_video)
            .then(() => {
              this.isCameraLoading = false;
              uploadLiveLog({
                message: `教师${
                  newVideoState ? "开启" : "关闭"
                }自己的摄像头成功`,
                level: "info",
                tag: "userAction",
                extra: {
                  component: "TeacherVideo",
                  action: "toggleSelfVideo",
                  newState: newVideoState,
                  userId: this.info.userID,
                },
              });
            })
            .catch((error) => {
              this.isCameraLoading = false;
              uploadLiveLog({
                message: `教师${
                  newVideoState ? "开启" : "关闭"
                }自己的摄像头失败`,
                level: "error",
                tag: "userAction",
                extra: {
                  component: "TeacherVideo",
                  action: "toggleSelfVideo",
                  error: error?.message || error,
                },
              });
            });
        }
      },
      300,
      true
    ),
    onVolumeChange(res) {
      if (this.info.isMe) {
        if (res.volume > 0 && res.userId === "" && !this.info.audioClose) {
          this.isSpeaking = true;
          this.$emit("speaking", this.info);
          clearTimeout(this.speakTimer);
          this.speakTimer = setTimeout(() => {
            this.isSpeaking = false;
          }, 1000);
        }
      } else {
        if (
          res.userId === this.info.userID &&
          res.volume > 0 &&
          !this.info.audioClose
        ) {
          this.isSpeaking = true;
          this.$emit("speaking", this.info);
          clearTimeout(this.speakTimer);
          this.speakTimer = setTimeout(() => {
            this.isSpeaking = false;
          }, 1000);
        }
      }
    },
    handleCommand(type) {
      if (type === "mirror") {
        uploadLiveLog({
          message: `教师${!this.isMirror ? "开启" : "关闭"}镜像`,
          level: "info",
          tag: "userAction",
          extra: {
            component: "TeacherVideo",
            action: "mirror",
            targetMirrorState: !this.isMirror,
          },
        });
        this.liveService.setMirror(!this.isMirror);
      } else if (type === "rename") {
        uploadLiveLog({
          message: "教师打开修改昵称弹窗",
          level: "info",
          tag: "userAction",
          extra: {
            component: "TeacherVideo",
            action: "rename",
            userId: this.info.userID,
            currentNickname: this.info.name,
          },
        });
        this.setShowChangeNickname({
          visible: true,
          info: {
            userId: this.info.userID,
            nickname: this.info.name,
          },
        });
      }
    },
    setUserRole(data) {
      return setUserRole({
        ...data,
        user_id: this.info.userID,
        room_id: this.roomInfo.id,
      });
    },
    // 停止本地摄像头采集
    stopLocalVideo() {
      this.liveService
        .stopLocalPreview()
        .then(() => {
          uploadLiveLog({
            message: "教师停止本地视频成功",
            level: "info",
            tag: "api",
            extra: {
              component: "TeacherVideo",
              action: "stopLocalVideo",
            },
          });
        })
        .catch((error) => {
          uploadLiveLog({
            message: "教师停止本地视频失败",
            level: "error",
            tag: "api",
            extra: {
              component: "TeacherVideo",
              action: "stopLocalVideo",
              error: error?.message || error,
            },
          });
        });
    },
    // 开启本地视频推流
    startLocalVideo() {
      console.log("preview_video____", this.$refs.preview_video);
      if (this.roomInfo.mode === 1) {
        // 极速模式不开启视频
        uploadLiveLog({
          message: "极速模式不开启视频",
          level: "info",
          tag: "api",
          extra: {
            component: "TeacherVideo",
            action: "startLocalVideo",
            mode: this.roomInfo.mode,
          },
        });
        return;
      }
      this.liveService.startLocalPreview({
        dom: this.$refs.preview_video,
        publish: true,
      });
      uploadLiveLog({
        message: "教师开启本地视频",
        level: "info",
        tag: "api",
        extra: {
          component: "TeacherVideo",
          action: "startLocalVideo",
        },
      });
    },
    // 暂停/开始本地音频推流 mute true 暂停 false 开启
    muteLocalAudio(mute) {
      this.liveService
        .muteLocalAudio({ mute: mute })
        .then(() => {
          // 更新本地状态记录
          this.lastAudioState = mute;
          console.log(`本地音频状态已更新: ${mute ? "静音" : "开启"}`);
          uploadLiveLog({
            message: `教师${mute ? "静音" : "取消静音"}本地音频成功`,
            level: "info",
            tag: "api",
            extra: {
              component: "TeacherVideo",
              action: "muteLocalAudio",
              mute,
            },
          });
        })
        .catch((error) => {
          console.error("本地音频状态切换失败:", error);
          uploadLiveLog({
            message: `教师${mute ? "静音" : "取消静音"}本地音频失败`,
            level: "error",
            tag: "api",
            extra: {
              component: "TeacherVideo",
              action: "muteLocalAudio",
              mute,
              error: error?.message || error,
            },
          });
          // 状态切换失败时，尝试修复
          // this.fixAudioState();
        });
    },
    // 开始拉远端视频
    startRemoteVideo() {
      const asyncFn = () => {
        return new Promise((resolve, reject) => {
          if (this.muteRemoteVideoState === false) {
            resolve();
            uploadLiveLog({
              message: "开始拉取远端教师视频流成功--当前状态相同",
              level: "info",
              tag: "api",
              extra: {
                component: "TeacherVideo",
                action: "startRemoteVideo",
                targetUserId: this.info.userID,
              },
            });
            return;
          }
          const params = {
            userID: this.info.userID,
            view: this.$refs.preview_video,
            streamType: 0,
          };
          this.liveService
            .startRemoteView(params)
            .then(() => {
              this.muteRemoteVideoState = false;
              resolve();
              uploadLiveLog({
                message: "开始拉取远端教师视频流成功",
                level: "info",
                tag: "api",
                extra: {
                  component: "TeacherVideo",
                  action: "startRemoteVideo",
                  targetUserId: this.info.userID,
                },
              });
            })
            .catch((error) => {
              reject(error);
              uploadLiveLog({
                message: "开始拉取远端教师视频流失败",
                level: "error",
                tag: "api",
                extra: {
                  component: "TeacherVideo",
                  action: "startRemoteVideo",
                  targetUserId: this.info.userID,
                  error: error?.message || error,
                },
              });
            });
        });
      };
      this.queueAsyncRemoteVideo(asyncFn);
    },
    // 停止拉远端视频
    stopRemoteVideo() {
      const asyncFn = () => {
        return new Promise((resolve, reject) => {
          if (this.muteRemoteVideoState === true) {
            resolve();
            uploadLiveLog({
              message: "停止拉取远端教师视频流成功--当前状态相同",
              level: "info",
              tag: "api",
              extra: {
                component: "TeacherVideo",
                action: "stopRemoteVideo",
                targetUserId: this.info.userID,
              },
            });
            return;
          }
          this.liveService
            .stopRemoteView({
              userID: this.info.userID,
              streamType: 0,
            })
            .then(() => {
              this.muteRemoteVideoState = true;
              resolve();
              uploadLiveLog({
                message: "停止拉取远端教师视频流成功",
                level: "info",
                tag: "api",
                extra: {
                  component: "TeacherVideo",
                  action: "stopRemoteVideo",
                  targetUserId: this.info.userID,
                },
              });
            })
            .catch((error) => {
              reject(error);
              uploadLiveLog({
                message: "停止拉取远端教师视频流失败",
                level: "error",
                tag: "api",
                extra: {
                  component: "TeacherVideo",
                  action: "stopRemoteVideo",
                  targetUserId: this.info.userID,
                  error: error?.message || error,
                },
              });
            });
        });
      };
      return this.queueAsyncRemoteVideo(asyncFn);
    },
    // 暂停/开启远端用户的音频 mute true 静音 false 关闭静音，仅对当前用户有效
    muteRemoteAudio(mute) {
      if (this.isScreenShareRemote && mute) {
        // 如果是快直播下台学生或助教，允许静音TRTC流（改用CDN流）
        if (
          this.roomInfo.is_quick_live === 1 &&
          (this.roomInfo.isStudent || this.roomInfo.isAssistant) &&
          this.userStatus.is_up_stage === 2 &&
          !this.isRecordPage
        ) {
          // 下台学生或助教需要正常静音TRTC流，不执行return，继续后面的正常逻辑
          uploadLiveLog({
            message:
              "快直播下台学生或助教在屏幕共享中，允许静音TRTC音频流（切换到CDN）",
            level: "info",
            tag: "api",
            extra: {
              component: "TeacherVideo",
              action: "muteRemoteAudio",
              targetUserId: this.info.userID,
              mute,
              is_up_stage: this.userStatus.is_up_stage,
            },
          });
        } else {
          // 其他情况（上台学生或助教或老师），保持原有逻辑：共享时不静音TRTC音频
          this.liveService.muteRemoteAudio({
            userId: this.info.userID,
            mute: false,
          });
          uploadLiveLog({
            message: "屏幕共享中，不静音远端教师音频",
            level: "info",
            tag: "api",
            extra: {
              component: "TeacherVideo",
              action: "muteRemoteAudio",
              targetUserId: this.info.userID,
              mute,
            },
          });
          return;
        }
      }
      this.liveService
        .muteRemoteAudio({
          userId: this.info.userID,
          mute: mute,
        })
        .then(() => {
          console.log(`远端音频状态已更新: ${mute ? "静音" : "开启"}`);
          uploadLiveLog({
            message: `${mute ? "静音" : "取消静音"}远端教师音频成功`,
            level: "info",
            tag: "api",
            extra: {
              component: "TeacherVideo",
              action: "muteRemoteAudio",
              targetUserId: this.info.userID,
              mute,
            },
          });
        })
        .catch((error) => {
          console.error("远端音频状态切换失败:", error);
          uploadLiveLog({
            message: `${mute ? "静音" : "取消静音"}远端教师音频失败`,
            level: "error",
            tag: "api",
            extra: {
              component: "TeacherVideo",
              action: "muteRemoteAudio",
              targetUserId: this.info.userID,
              error: error?.message || error,
            },
          });
        });
      // const asyncFn = () => {
      //   return new Promise((resolve, reject) => {
      //     if (this.muteRemoteAudioState === mute) {
      //       resolve();
      //       uploadLiveLog({
      //         message: `${
      //           mute ? "静音" : "取消静音"
      //         }远端教师音频成功--当前状态相同`,
      //         level: "info",
      //         tag: "api",
      //         extra: {
      //           component: "TeacherVideo",
      //           action: "muteRemoteAudio",
      //           targetUserId: this.info.userID,
      //           mute,
      //         },
      //       });
      //       return;
      //     }
      //     this.liveService
      //       .muteRemoteAudio({
      //         userId: this.info.userID,
      //         mute: mute,
      //       })
      //       .then(() => {
      //         this.muteRemoteAudioState = mute;
      //         console.log(`远端音频状态已更新: ${mute ? "静音" : "开启"}`);
      //         resolve();
      //         uploadLiveLog({
      //           message: `${mute ? "静音" : "取消静音"}远端教师音频成功`,
      //           level: "info",
      //           tag: "api",
      //           extra: {
      //             component: "TeacherVideo",
      //             action: "muteRemoteAudio",
      //             targetUserId: this.info.userID,
      //             mute,
      //           },
      //         });
      //       })
      //       .catch((error) => {
      //         console.error("远端音频状态切换失败:", error);
      //         reject(error);
      //         uploadLiveLog({
      //           message: `${mute ? "静音" : "取消静音"}远端教师音频失败`,
      //           level: "error",
      //           tag: "api",
      //           extra: {
      //             component: "TeacherVideo",
      //             action: "muteRemoteAudio",
      //             targetUserId: this.info.userID,
      //             error: error?.message || error,
      //           },
      //         });
      //       });
      //   });
      // };
      // return this.queueAsyncRemoteAudio(asyncFn);
    },
  },
};
</script>

<style lang="scss" scoped>
.teacher-container {
  width: 156px;
  height: 88px;
  border-radius: 6px;
  border: 2px solid transparent;
  position: relative;
  overflow: hidden;
  box-sizing: content-box;
  &.speaking-box {
    border-color: #23c343;
  }

  .video-box {
    width: 100%;
    height: 100%;
    border-radius: 0;
    overflow: hidden;
    background: #27272a;
  }

  .close-placeholder {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: 1;
    background: #27272a;
    display: flex;
    justify-content: center;
    align-items: center;

    img {
      width: 48px;
      height: 48px;
      border-radius: 50%;
      object-fit: cover;
    }
  }

  video {
    width: 156px !important;
    height: 88px !important;
    border-radius: 6px;
  }

  .handle-box {
    position: absolute;
    top: 4px;
    right: 4px;
    z-index: 1;
    width: 100%;
    height: 24px;
    display: none;
    justify-content: flex-end;
    align-items: center;

    .handle-item {
      width: 24px;
      height: 24px;
      background: rgba(24, 24, 27, 0.6);
      border-radius: 6px 6px 6px 6px;
      border: 1px solid rgba(24, 24, 27, 0.1);
      margin-left: 4px;
      cursor: pointer;
      display: flex;
      justify-content: center;
      align-items: center;

      img {
        width: 18px;
        height: 18px;
      }
    }
  }

  .info-box {
    max-width: 90%;
    padding: 0 4px 0 2px;
    height: 20px;
    background: rgba(24, 24, 27, 0.6);
    border-radius: 6px;
    border: 1px solid rgba(24, 24, 27, 0.1);
    display: flex;
    justify-content: flex-start;
    align-items: center;
    position: absolute;
    left: 2px;
    bottom: 2px;
    z-index: 2;

    .role {
      width: 30px;
      min-width: 30px;
      height: 14px;
      background: #052814;
      border-radius: 4px;
      font-weight: 500;
      font-size: 10px;
      color: #17c964;
      display: flex;
      justify-content: center;
      align-items: center;
    }

    img {
      margin-left: 2px;
      widows: 14px;
      height: 14px;
    }

    .name {
      margin-left: 2px;
      font-weight: 500;
      font-size: 12px;
      color: #ffffff;
    }

    .me-tag {
      font-size: 14px;
      font-size: 14px;
      color: #ffffff;
    }
  }

  &:hover {
    .handle-box {
      display: flex;
    }
  }
}

.person-dropdown-menu ::v-deep {
  width: 128px;
  background: #18181b;
  box-shadow: 0px 8px 60px 2px rgba(0, 0, 0, 0.8);
  border-radius: 8px;
  border: 1px solid rgba(229, 231, 235, 0.04);
  padding: 0;

  .popper__arrow {
    display: none;
  }

  li {
    font-weight: 500;
    font-size: 14px;
    color: #ecedee;
    line-height: 20px;
    height: 36px;
    border-bottom: 1px solid rgba(229, 231, 235, 0.04);
    display: flex;
    align-items: center;
    justify-content: center;

    &:last-child {
      border-bottom: none;
    }

    &:hover {
      background: transparent;
      color: #ecedee;
    }
  }
}
</style>
